<template>
    <b-link v-bind="$attrs" v-on="$listeners" :to="{ name: 'ForgotPassword' }" class="link-forget-password">
        {{ $t('text') }}
    </b-link>
</template>

<script>
export default {
    name: 'LinkForgotPassword',
    i18n: {
        messages: {
            'en-US': {
                text: 'Forgot your password?',
            },
            'es-ES': {
                text: '¿Olvidaste tu contraseña?',
            },
            'pt-BR': {
                text: 'Esqueceu a senha?',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
a.link-forget-password {
    font-size: 1em;
    font-weight: 700;
    color: #009ada;
}
</style>
